import { render, staticRenderFns } from "./navbar-small.vue?vue&type=template&id=bd90de10"
import script from "./navbar-small.vue?vue&type=script&lang=ts"
export * from "./navbar-small.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIconLogo: require('/vercel/path0/components/ui/icon/logo.vue').default,UiIconLockWithIcon: require('/vercel/path0/components/ui/icon/lock-with-icon.vue').default})
